import { ActionReducerMap } from '@ngrx/store';

import * as fromAuth from './auth/auth.reducer';
import * as fromUser from './user/user.reducer';
import * as fromSite from './site/site.reducer';
import * as fromHome from './home/home.reducer';
import * as fromTicket from './ticket/ticket.reducer';
import * as fromEvent from './event/event.reducer';
import * as fromDevice from './device/device.reducer';
import * as fromTask from './task/task.reducer';
import * as fromDeviceBoardusers from './device-boardusers/device-boardusers.reducer';
import * as fromDeviceList from './device-list/device-list.reducer';
import * as fromDeviceTh from './device-th/device-th.reducer';
import * as fromDeviceVct from './device-vct/device-vct.reducer';
import * as fromDeviceMtma from './device-mtma/device-mtma.reducer';
import * as fromInvitations from './invitations/invitations.reducer';
import * as fromNotifications from './notifications/notifications.reducer';
import * as fromPermission from './permissions/permissions.reducer';
import * as fromSiteMap from './site-map/site-map.reducer';
import * as fromSiteList from './site-list/site-list.reducer';
import * as fromUserFile from './user-file/user-file.reducer';
import * as fromScenery from './scenery/scenery.reducer';
import * as fromSchedule from './schedule/schedule.reducer';
import * as fromCalendar from './calendar/calendar.reducer';
import * as fromHelp from './help/help.reducer';
import * as fromCameService from './service/service.reducer';
import * as fromAnalytics from './analytics/analytics.reducer';
import * as fromSoftwareUpdates from './software-updates/software-updates.reducer';

export interface AppState {
  auth: fromAuth.State;
  user: fromUser.State;
  site: fromSite.State;
  home: fromHome.State;
  device: fromDevice.State;
  ticket: fromTicket.State;
  event: fromEvent.State;
  task: fromTask.State;
  deviceBoardusers: fromDeviceBoardusers.State;
  deviceList: fromDeviceList.State;
  deviceTh: fromDeviceTh.State;
  deviceVct: fromDeviceVct.State;
  deviceMtma: fromDeviceMtma.State;
  invitations: fromInvitations.State;
  notifications: fromNotifications.State;
  permission: fromPermission.State;
  siteMap: fromSiteMap.State;
  siteList: fromSiteList.State;
  userFile: fromUserFile.State;
  scenery: fromScenery.State;
  schedule: fromSchedule.State;
  calendar: fromCalendar.State;
  cameService: fromCameService.State;
  help: fromHelp.State;
  analytics: fromAnalytics.State;
  softwareUpdates: fromSoftwareUpdates.State;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: fromAuth.reducer,
  user: fromUser.reducer,
  site: fromSite.reducer,
  device: fromDevice.reducer,
  home: fromHome.reducer,
  ticket: fromTicket.reducer,
  event: fromEvent.reducer,
  task: fromTask.reducer,
  deviceBoardusers: fromDeviceBoardusers.reducer,
  deviceList: fromDeviceList.reducer,
  deviceTh: fromDeviceTh.reducer,
  deviceVct: fromDeviceVct.reducer,
  deviceMtma: fromDeviceMtma.reducer,
  invitations: fromInvitations.reducer,
  notifications: fromNotifications.reducer,
  permission: fromPermission.reducer,
  siteMap: fromSiteMap.reducer,
  siteList: fromSiteList.reducer,
  userFile: fromUserFile.reducer,
  scenery: fromScenery.reducer,
  schedule: fromSchedule.reducer,
  calendar: fromCalendar.reducer,
  cameService: fromCameService.reducer,
  help: fromHelp.reducer,
  analytics: fromAnalytics.reducer,
  softwareUpdates: fromSoftwareUpdates.reducer,
};
